import { runInAction } from 'mobx';

import { TableStateChangeType } from '../../model/enumeration/TableStateChangeType.enum';
import { WTableSyncGameTable } from '../../model/websocket/WTableSyncGameTable';
import eventLogsStore from '../../store/EventLogsStore';
import gameStore from '../../store/GameStore';
import { GameTable } from '../../store/state/GameTable';
import tableStore from '../../store/TableStore';
import { WEvent } from './WEvent';
import { WWaitlistSyncEvent } from './WWaitlistSyncEvent';

export class WTableSyncEvent extends WEvent {
  table: WTableSyncGameTable;
  changeType: TableStateChangeType;
  waitlistSyncEvent: WWaitlistSyncEvent;

  constructor(event: WTableSyncEvent) {
    super(event.tableId, event.eventType, event.eventTime);
    Object.assign(this, event);
  }

  applyWebsocketChanges = (): Promise<void> => {
    const table =
      tableStore.getActiveTableById(this.tableId) ?? new GameTable();
    if (table.deleted) {
      table.setDeleted(false);
    }
    table.setWaitlistCount(this.waitlistSyncEvent.pids.length);
    runInAction(() => Object.assign(table, this.table));
    tableStore.addTableIfNotExists(table);
    eventLogsStore.emptyLogs(table.id);

    if (this.changeType === TableStateChangeType.GAME_STARTED) {
      gameStore.removeGameByTableId(table.id);
    }
    tableStore.changeFilterState();
    return Promise.resolve();
  };
}
